// extracted by mini-css-extract-plugin
module.exports = {"title":"Banner_title__1ufIp","banner":"Banner_banner__2eQ2r","image":"Banner_image__3SPqO"};